import { Routes } from '@angular/router';
import { LanguageGuard } from '@pyg-services/language/language.guard';
import { inject } from '@angular/core';
import { LanguageService } from '@pyg-services/language/language.service';
import { RenderMode } from '@angular/ssr';

export const appRoutes: Routes = [
  {
    path: '',
    data: { renderMode: RenderMode.Server },
    redirectTo: () => {
      const langService = inject(LanguageService);
      return langService.getInitLang();
    },
    pathMatch: 'full',
  },
  {
    path: ':lang',
    canActivate: [LanguageGuard],
    children: [
      {
        path: '',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/main-page/main-page.component').then(
            (m) => m.MainPageComponent,
          ),
      },
      {
        path: 'solutions',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/products/products.component').then(
            (m) => m.ProductsComponent,
          ),
      },
      {
        path: 'innovation',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/innovation/innovation.component').then(
            (m) => m.InnovationComponent,
          ),
      },
      {
        path: 'platform',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/platform/platform.component').then(
            (m) => m.PlatformComponent,
          ),
      },
      {
        path: 'case-studies',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/case-studies/case-studies.component').then(
            (m) => m.CaseStudiesComponent,
          ),
      },
      {
        path: 'about',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/about/about.component').then(
            (m) => m.AboutComponent,
          ),
      },
      {
        path: 'industries/retail',
        data: { renderMode: RenderMode.Prerender, industry: 'retail' },
        loadComponent: () =>
          import(
            '@pyg-components/industry-page/industry-page.component'
          ).then((m) => m.IndustryPageComponent),
      },
      {
        path: 'industries/malls',
        data: { renderMode: RenderMode.Prerender, industry: 'malls' },
        loadComponent: () =>
          import(
            '@pyg-components/industry-page/industry-page.component'
          ).then((m) => m.IndustryPageComponent),
      },
      {
        path: 'industries/telecom-banking',
        data: { renderMode: RenderMode.Prerender, industry: 'telecom_banking' },
        loadComponent: () =>
          import(
            '@pyg-components/industry-page/industry-page.component'
          ).then((m) => m.IndustryPageComponent),
      },
      {
        path: 'industries/forecourt',
        data: { renderMode: RenderMode.Prerender, industry: 'forecourt' },
        loadComponent: () =>
          import(
            '@pyg-components/industry-page/industry-page.component'
          ).then((m) => m.IndustryPageComponent),
      },
      {
        path: 'blog',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/blog/blog.component').then(
            (m) => m.BlogComponent,
          ),
      },
      {
        path: 'blog/:article',
        data: { renderMode: RenderMode.Prerender, isArticle: true },
        loadComponent: () =>
          import('@pyg-components/blog/article/article.component').then(
            (m) => m.ArticleComponent,
          ),
      },
      {
        path: 'futureoftelco',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import(
            '@pyg-components/future-of-telco/future-of-telco.component'
          ).then((m) => m.FutureOfTelcoComponent),
      },
      {
        path: 'privacy-policy',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import(
            '@pyg-components/privacy-policy/privacy-policy.component'
          ).then((m) => m.PrivacyPolicyComponent),
      },
      {
        path: 'virtual-queue',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/virtual-queue/virtual-queue.component').then(
            (m) => m.VirtualQueueComponent,
          ),
      },
      {
        path: 'museums',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/museums/museums.component').then(
            (m) => m.MuseumsComponent,
          ),
      },
      {
        path: 'customer-journey-analytics-and-service-monitoring-with-tdi',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import(
            '@pyg-components/tdi-landing-page/tdi-landing-page.component'
          ).then((m) => m.TdiLandingPageComponent),
      },
      {
        path: 'contact_us',
        data: { renderMode: RenderMode.Prerender },
        loadComponent: () =>
          import('@pyg-components/demo-form/demo-form.component').then(
            (m) => m.DemoFormComponent,
          ),
      },
      {
        path: 'journey-assessment',
        data: { renderMode: RenderMode.Prerender, isStatic: true },
        loadComponent: () => import('@pyg-components/journey/journey.component').then(m => m.JourneyComponent),
      },
      // Redirects
      {
        path: 'in-store-analytics',
        data: { renderMode: RenderMode.Server },
        redirectTo: 'solutions',
      },
      {
        path: 'products',
        data: { renderMode: RenderMode.Server },
        redirectTo: 'solutions',
      },
      {
        path: 'pygmalios-for-frontline-teams',
        data: { renderMode: RenderMode.Server },
        redirectTo: 'innovation',
      },
      {
        path: 'pygmalios-x',
        data: { renderMode: RenderMode.Server },
        redirectTo: 'innovation',
      },
      {
        path: 'shopguard',
        data: { renderMode: RenderMode.Server },
        redirectTo: 'solutions',
      },
      {
        path: 'tdi',
        data: { renderMode: RenderMode.Server },
        redirectTo:
          'customer-journey-analytics-and-service-monitoring-with-tdi',
      },
      {
        path: 'contact',
        data: { renderMode: RenderMode.Server },
        redirectTo: 'contact_us',
      },
      {
        path: 'getdemo',
        data: { renderMode: RenderMode.Server },
        redirectTo: 'contact_us',
      },
      {
        path: '**',
        data: { renderMode: RenderMode.Server },
        redirectTo: '',
      },
    ],
  },
];
